module.exports = __webpack_public_path__ + "img/3bb9fa7.png";